import React, { useEffect } from 'react';
import './App.css';
import Regen from './Regen';
import defaultImage from './images/default.jpg';

function App() {  
  const env = {
    "size":"1152",
    "amount":6666,
    "contract":"0x56dfe6ae26bf3043dc8fdf33bf739b4ff4b3bc4a",
    "api":"1599fc5a88d4442694bc95bf27761e3a",
  }

  const blings = [
        { id: 0, name: 'Naked', imageName: 'none', trait_type: '', sex: false },
        { id: 1, name: 'Gun', imageName: 'gun', trait_type: 'type', sex: false },
        { id: 2, name: 'Santa', imageName: 'santa', trait_type: '', sex: false },
        { id: 3, name: 'Banana', imageName: 'banana', trait_type: '', sex: false },
        { id: 4, name: 'Rainbow', imageName: 'rainbow-border', trait_type: '', sex: false },
        { id: 5, name: 'Mask', imageName: 'mask', trait_type: 'type', sex: true },
        { id: 6, name: 'Crown', imageName: 'crown', trait_type: 'type', sex: '_type' },
        { id: 7, name: 'Leatherface', imageName: 'leatherface', trait_type: '', sex: false},
        { id: 8, name: 'Michael', imageName: 'michael', trait_type: '', sex: false},
        { id: 9, name: 'Grabber', imageName: 'grabber', trait_type: '', sex: false},
        { id: 10, name: 'Ghostface', imageName: 'ghostface', trait_type: '', sex: false},
        { id: 11, name: 'Jason', imageName: 'jason', trait_type: '', sex: false},
        { id: 12, name: 'Hannibal', imageName: 'hannibal', trait_type: '', sex: false}
  ];

  // const oneoffs = [ 1596, 5416 ];
``
  return (
    <div className="page-wrap">
      <Regen 
      amount={env.amount}
      apikey={env.api}
      contract={env.contract}
      bg={defaultImage}
      size={env.size}
      blings={blings}
      />
    </div>
  )
}

export default App;